import React, { Fragment, useEffect } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Header as DsHeader, Logo } from '@vmos2/design-system';
import { useHybridApp } from '@vmos2/utils';

import { UserButton } from './components/header/UserButton';
import { HiddenMenu } from './components/header/hiddenMenu';

export const Header = () => {
  const { hybridApp, setStatusBarStyleFromTheme } = useHybridApp();
  const { isReactNativeApp } = hybridApp || {};
  const theme = useTheme();

  useEffect(() => setStatusBarStyleFromTheme(theme), [theme]);

  const renderLogo = () => {
    if (isReactNativeApp) {
      return (
        <HiddenMenu as={LogoWrapper}>
          <Logo/>
        </HiddenMenu>
      );
    }
    return <LogoWrapper as={Logo} />;
  };

  return (
    <HeaderWrapper
      hasShadow
      mode="Main"
      topNav={
        <Fragment>
          {renderLogo()}
          <UserButton />
        </Fragment>
      }
    />
  );
};

const HeaderWrapper = styled(DsHeader)`
  position: fixed;
  top: 0;
  left: 0;
`;

const LogoWrapper = styled('span')`
  line-height: 0;
`;
